import ProductListTab from './productListTab'
import Topbar from './topbar'
import TypeList from './typeList'
import YouLike from './youLike'
import MoreBooklist from './moreBooklist'
import CategoryList from './categoryList'
import { Modal } from 'antd-mobile'
import Jockeys from '@/utils/jockey'
import { compareVersion, getAppVersion, isDuApp } from '@/utils/appUtils/getDevice'
import appInstall from '@/utils/appUtils/appInstall'

export { ProductListTab, Topbar, TypeList, YouLike, MoreBooklist, CategoryList }

// 点击缺货标签弹窗
export const handleBreakCode = async (langConfig, breakCodeTag, spuId, trackHelper) => {
  const message = <span style={{ color: '#2B2C3C' }}>{langConfig.OOSExplain}</span>
  Modal.alert(null, message, [
    {
      text: langConfig.cancel,
      style: { color: '#7F7F8E', fontSize: 16 },
      onPress: () => {
        trackHelper('poizon_common_click', {
          current_page: 515,
          block_type: 3280,
          product_id: spuId,
          button_title: langConfig.cancel,
        })
      },
    },
    {
      text: langConfig.viewList,
      style: { color: '#16A5AF', fontSize: 16 },
      onPress: () => {
        if (isDuApp() && compareVersion(getAppVersion(), '2.1.5') !== -1) {
          Jockeys.openNativePage('/bor/index', {
            level1CategoryId: 0,
            tagType: breakCodeTag,
          })
          return
        }
        appInstall('/bor/index', { level1CategoryId: 0, tagType: breakCodeTag })
        trackHelper('poizon_common_click', {
          current_page: 515,
          block_type: 3280,
          product_id: spuId,
          button_title: langConfig.viewList,
        })
      },
    },
  ])
}
